import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { combineLatest, from, Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { ModuleService } from '../../Services/module.service';
import { FieldService } from './fields/field.service';


export interface StepData {
  selectedStepId: string;
  hasPrimaryFields: boolean;
  hasDrivingFields: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class StepResolveGuard  {
  constructor(private fieldService: FieldService, private moduleService: ModuleService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<StepData> {
    let stepId = route.queryParams['stepId'];
    let hasDrivingFields =
      this.fieldService.getDrivingFields()
        .pipe(
          map(drivingFields => drivingFields && drivingFields.length > 0));
    let hasPrimaryFields =
      this.moduleService.getStepHasPrimaryFields();

    return from(this.moduleService.getStepFields(stepId))
      .pipe(() => {
        return combineLatest([hasPrimaryFields, hasDrivingFields])
          .pipe(
            map(([hasPrimaryFields, hasDrivingFields]) => {
              let stepData: StepData = {
                selectedStepId: stepId,
                hasPrimaryFields,
                hasDrivingFields,
              };
              return stepData;
            }),
            take(1)
          );
      });
  }
}
